import { WizardItemType } from '@gimlite/ui-v1';
import { useEffect } from 'react';
import { ProductCategoryEnum } from '../../../../client/graphql';
import { ProductForm } from '../../../../form/product/product.form';
import { CreateNewMasterPoolContractWizardContext } from '../../createNewMasterPoolContract.wizard';

export const ProductStep = ({
  context: { product, parkingId, contractBase },
  validate,
  submit,
}: WizardItemType.Config.Component<CreateNewMasterPoolContractWizardContext>) => {
  useEffect(() => {
    validate(!!product.id);
  }, [product]);

  return parkingId ? (
    <ProductForm
      handleEvent={{
        select: ({ id, period, APBMode, credentials, articleCodes }) => {
          submit({
            product: {
              period,
              id,
              credentials: credentials || [],
              articleCodes,
            },
            contractBase: {
              ...contractBase,
              startDate: new Date().toISOString(),
              APBMode: APBMode,
              articleCode: articleCodes[0]?.code || null,
            },
            tenant: {
              name1: null,
              name2: null,
              address1: null,
              address2: null,
              city: null,
              country: 'CHE',
              zipCode: null,
              hasAdminPool: false,
              canCreateSubContract: false,
            },
            poolAdmin: {
              firstName: null,
              lastName: null,
              lang: null,
              phone: null,
              username: null,
            },
            contracts: {
              checked: [],
              created: [],
            },
            contractExistedSave: [],
          });
        },
      }}
      data={{
        parkingId,
        productId: product.id,
        category: ProductCategoryEnum.OperatorPool,
      }}
    />
  ) : null;
};
